// extracted by mini-css-extract-plugin
export default {"input":"style_input__MxhkA","icon":"style_icon__R7tTz"};